import React, { Component } from 'react';
import { Typography, Tooltip, Popconfirm } from 'antd';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { amountToString } from '../../../util/tool';
import { IndexToStatusText, IndexToOrderTypeText } from '../utils/common';
import { showNumber } from '../utils/common';
import './renderlist.less';

export default class RenderList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      titleConfig: [
        {
          "name": "商品",
          "rolWidth": 1
        },
        {
          "name": "价格(元）",
          "rolWidth": 1
        },
        // {
        //   "name": "税率",
        //   "rolWidth": 1
        // },
        // {
        //   "name": "商品价格(含税)",
        //   "rolWidth": 1
        // },
        {
          "name": "数量",
          "rolWidth": 1
        },
        {
          "name": "总金额(元）",
          "rolWidth": 1
        },
        {
          "name": "订货单状态",
          "rolWidth": 1
        },
        // {
        //   "name": "交易操作",
        //   "rolWidth": 1
        // }
      ]
    };
  }

  renderDetail = (info) => {
    // const parseInfo = JSON.parse((info));
    // const surcharge_desc = !info ? [] : parseInfo;
    // const record = { qoute: { surcharge_desc } };
    // return <RenderPopover record={record} />;
  }

  render() {
    const { titleConfig = [] } = this.state;
    const { formateList = [], toOrderDetail, cancelOrder, againOrder,  expandFn = () => { }, onHandlerSpot, toProductDetail = () => { } } = this.props;
    return (
      <div className='render-list-container-proposal'>
        <div className='render-list-title'>{titleConfig.map((item, index) => <div className={index < titleConfig.length - 4 ? (index > 0 ? 'render-list-title-item-normal1' : 'render-list-title-item') : 'render-list-title-item-normal2'} key={index}>{item.name}</div>)}</div>
        <div className='render-list-content'>
          {
            formateList.map(item => {
              // const buttonsConfirmedStatus = item.receiveInfo?.length ? 100 : 0;
              return (
                <div className='render-list-content-container' key={item.order_no}>
                  <div className='render-list-content-title'>
                    <div>订货来源：{IndexToOrderTypeText[item.order_type]}</div>
                    <div>订货单号：{item.order_no}</div>
                    <div>下单时间：{item.create_time}</div>
                    <div>
                      <span className='service pointer' onClick={() => onHandlerSpot(item)}></span>
                      <Tooltip title={item.purchase_name}>{item?.supplier_name?.length > 10 ? item?.supplier_name?.slice(0, 10) + '...' : item?.supplier_name} </Tooltip>
                    </div>
                    {/* <div>期望到货日期：{item.expectedDate}</div> */}
                  </div>
                  <div className='render-list-content-products-container'>
                    <div className='render-list-content-products-container-left'>
                      {item.product.slice(0, item.isExpand ? showNumber : item.product.length).map((subItem, subIndex) => (
                        <div className='render-list-content-products-item' key={subIndex}>
                          <div className='render-list-content-detail'>
                            <div className='render-list-content-detail-product'>
                              <div className='render-list-content-detail-product-left'><img src={subItem.sale_image} alt="" /></div>
                              <div className='render-list-content-detail-product-right'>
                                <div className='pointer render-list-content-detail-product-right-title' onClick={() => toProductDetail(subItem)}>{subItem.sale_name}</div>
                                <div>单位：{subItem.sale_unit}</div>
                              </div>
                            </div>
                            <div className='render-list-content-detail-item'>¥ {`${subItem.norms_price} / ${subItem.sale_unit}`}</div>
                            {/* <div className='render-list-content-detail-item'>{subItem.tax_rate >= 0 ? (+subItem.tax_rate + '%') : '-'}</div> */}
                            {/* <div className='render-list-content-detail-item'>
                              <div style={{ display: 'flex', justifyContent: 'center' }}>{subItem.tax_inclusive_price === '-' ? '' : <>￥{amountToString(subItem.tax_inclusive_price)}</>} {this.renderDetail(subItem.surcharge_desc)}</div>
                            </div> */}
                            <div className='render-list-content-detail-item'>X{(+subItem.number)}</div>
                          </div>
                        </div>
                      ))}

                      {item.product.length > showNumber ?
                        <div className='render-list-content-expand pointer' onClick={() => expandFn(item)}>
                          {item.isExpand ? <span><span>共<Typography.Link>{item.product.length}</Typography.Link>种商品，查看全部</span><DownOutlined /></span> : <span><span>收起</span><UpOutlined /></span>}
                        </div> : null}
                    </div>
                    <div className='render-list-content-products-container-right'>
                      <div className='render-list-content-products-container-right-item'>¥ {amountToString(item.order_price)}</div>
                      <div className='render-list-content-products-container-right-item'>
                        <div><Typography.Link>{IndexToStatusText[+item?.order_status]}</Typography.Link></div>
                        <div className='pointer' onClick={() => { toOrderDetail(item); }}>订单详情</div>
                        {item?.order_status === 20 ? <div><Popconfirm title="请确认是否取消订货单?" onConfirm={() => cancelOrder(item)} okText="确认" cancelText="取消">
                          <Typography.Link>取消</Typography.Link>
                        </Popconfirm></div> : null}
                        {item?.order_status === 30 ? <div className='pointer' onClick={() => { againOrder(item); }}>再来一单</div> : null}
                        {item?.order_status === 40 ? <div className='pointer' onClick={() => { againOrder(item); }}>重新下单</div> : null}
                        {/* {((item.deliveryType === '3' || item.deliveryType === 3) && (item.orderStatus === 30 || item.orderStatus === 40)) ? <div className='pointer' style={{ marginTop: 8 }}><span onClick={() => { handleLogistics(item); }}>查看物流</span></div> : null} */}
                      </div>
                      {/* <div className='render-list-content-products-container-right-item'>
                        <div className='pointer' style={{ color: (item.orderStatus === 30 ? '#007AFF' : '#000') }}>
                          <Popconfirm title='确定取消订单' onConfirm={() => { btnClicked(item); }}>
                            <Typography.Link>{item.buttonText}</Typography.Link>
                          </Popconfirm>
                          {(item.orderStatus === 30) && <Popconfirm title={`确定${item.orderStatus === 20 ? '取消' : `${item.receiveInfo.length ? '完结订单' : '收货'}`}?`} onConfirm={() => { changeStatus(item); }}>
                            <Typography.Link>{statusToButtonsConfirmed[buttonsConfirmedStatus]}</Typography.Link>
                          </Popconfirm>}
                          {item.isInformation === 0 ? <div onClick={() => perfectInformation(item)}><Typography.Link>完善收货信息</Typography.Link></div> : null}
                        </div>
                      </div> */}
                    </div>
                  </div>
                </div>
              );
            })
          }
        </div>
      </div>
    );
  }
}
